import { AiAssistantFeatureTypes } from "src/features/aiAssistant/types";
export const aiAssistantFeatures = [
    { id: '1', type: AiAssistantFeatureTypes.ActionPoints, active: false },
    { id: '2', type: AiAssistantFeatureTypes.Title, active: false },
    { id: '3', type: AiAssistantFeatureTypes.Summary, active: false },
    { id: '4', type: AiAssistantFeatureTypes.Combined, active: true },
];
export const activeAiAssistantFeatures = aiAssistantFeatures.filter(item => item.active);
